import { Movax } from './Movax';
import { Validator } from './Validator';
import * as $ from 'jquery';

// jquery does not currently support es6 way of importing so we need to do it old school
var  Mustache = require('mustache'),
    _ = require('underscore'),
    validator = new Validator();

/**
 * create product search
 * @class
 */
class ProductSearch {
  private jsBlock: string;
  private dom = {
    $el: null,
    $makeSelect: null,
    $excavatorMakeModelRow: null,
    $excavatorSelectHolder: null,
    $excavatorSelect: null,
    $excavatorSearchInputs: null,
    $groundVibrationSelect: null,
    $resultsHolder: null,
    $results: null,
    $noResults: null
  };
  private excavatorsData;
  private excavatorClasses;
  private productResultsInfo;
  private productData;
  private validator;
  private listTemplate;
  private searchGroups;
  private excavatorModelProducts = [];

  private searchCriteria = {
    sizeClass: null,
    power: null,
    groundVibration: null
  };

  constructor(private id: string, private block: string) {
    this.jsBlock = 'js-' + block;
    this.dom.$el = $('#' + id);
  }

  private _getMakeData(makeUuid) {
    var i, l;

    for (i = 0, l = this.excavatorsData.length; i < l; i++ ) {
      if (this.excavatorsData[i].uuid === makeUuid) {
        return this.excavatorsData[i];
      }
    }

    return null;
  }

  private _updateExcavatorSelectHTML(models) {
    var html = '',
        i, l;

    html += '<option value="-1">' + this.dom.$excavatorSelect.data('empty-option-text') + '</option>';
    for (i = 0, l = models.length; i < l; i++) {
      html += '<option value="' + _.escape(JSON.stringify(models[i].products)) + '">' + models[i].model + '</option>';
    }
    this.dom.$excavatorSelect.html(html);
    this.dom.$excavatorSelect.trigger('change');
  }

  private _updateExcavatorSelect(makeUuid:string) {
    var makeData = this._getMakeData(makeUuid),
        models = makeData && makeData.models || [];

    if(models.length) {
      this._updateExcavatorSelectHTML(models);
      this.dom.$excavatorSelectHolder.show(200);
    } else {
      this.dom.$excavatorSelectHolder.hide(200);
    }
  }

  private _initExcavatorSelect() {
    var self = this;

    this.dom.$excavatorMakeModelRow = this.dom.$el.find('.' + this.jsBlock + '__excavator-make-model-row');
    this.dom.$excavatorSelectHolder = this.dom.$excavatorMakeModelRow.find('.' + this.jsBlock + '__excavator-select-holder');
    this.dom.$excavatorSelect = this.dom.$excavatorSelectHolder.find('.' + this.jsBlock + '__excavator-select');

    this.dom.$excavatorSelect.on('change', function () {
      var products = $(this).val(),
          results = [];

      if(products === '-1') {
        //self._toggleResults(false);
        self.excavatorModelProducts = [];
        //
      } else {
        //self._toggleResults(true);

        self.excavatorModelProducts = products;

      }

      results = self._filterProducts('groundVibration', self.searchCriteria.groundVibration, self._getProducts(self.excavatorModelProducts));

      self._showResults(results);

      return;
    });
  }

  private _toggleResults(showResults:boolean) {
    if(showResults) {
      this.dom.$resultsHolder.show(200);
    } else {
      this.dom.$resultsHolder.hide(200);
    }
  }
  private _initMakeSelect() {
    var self = this;

    this.dom.$makeSelect = this.dom.$el.find('.' + this.jsBlock + '__make-select');

    this.dom.$makeSelect.on('change', function() {
      var value = $(this).val();
      self._updateExcavatorSelect(value);
      //self._toggleResults(false);
    });
  }

  private _initGroundVibrationSelect() {
    var self = this;

    this.dom.$groundVibrationSelect = this.dom.$el.find('.' + this.jsBlock + '__ground-vibration-radio');

    this.dom.$groundVibrationSelect.on('change', function () {
      var $this = $(this);
      self._changeSearchCriteria({'groundVibration': $this.val()});
    });

    // Set initial value, no search triggered
    this.searchCriteria.groundVibration = this.dom.$groundVibrationSelect.filter(':checked').val();
  }

  private _initResults() {
    this.dom.$resultsHolder = this.dom.$el.find('.' + this.jsBlock + '__results-holder');
    this.dom.$results = this.dom.$resultsHolder.find('.' + this.jsBlock + '__results');
    this.dom.$noResults = this.dom.$resultsHolder.find('.' + this.jsBlock + '__no-results');
  }

  private _getProducts(uuids) {
    var filteredProducts = [],
        i, l;

    if(this.productData) {
      for (i = 0, l = this.productData.length; i < l; i++) {
        if(uuids.indexOf(this.productData[i].uuid) !== -1) {
          filteredProducts.push(this.productData[i]);
          if(filteredProducts.length === uuids.length) {
            break;
          }
        }
      }
    }

    return filteredProducts;
  }

  private _showResults(products:Array<any>) {

    var productsHtml = Mustache.render(this.listTemplate, {'items': products});

    if (products.length) {
      this.dom.$results.html(productsHtml);
      this.dom.$results.show(200);
      this.dom.$noResults.hide(200);
    } else {
      this.dom.$results.hide(200);
      this.dom.$noResults.show(200);
    }
  }

  private _searchByExcavatorClass(value: number) {
    var results = [], eClass, i, l;

    for (i = 0, l = this.excavatorClasses.length; i < l; i++) {
      eClass = this.excavatorClasses[i];

      if(value >= eClass.min && value <= eClass.max) {
        results = results.concat(eClass.products);
      }
    }

    return results;
  }

  private _initExcavatorClassSearch() {
    var self = this,
        invalidClass = validator.getFieldInvalidClass();

    this.dom.$excavatorSearchInputs = this.dom.$el.find('.' + this.jsBlock + '__excavator-search-input');
    //this.dom.$excavatorPowerInput = this.dom.$el.find('.' + this.jsBlock + '__excavator-power-input');

    this.dom.$excavatorSearchInputs.on('keyup', function () {
      var $this = $(this),
          value = $this.val(),
          searchCriteria = {},
          results = [];

      // If this field has value, close excavator make & model as this overrides them
      if($this.val()) {
        self.dom.$excavatorMakeModelRow.hide(200);
      } else {
        self.dom.$excavatorMakeModelRow.show(200);
      }

      // Validate field
      if(validator.validateField(this)) {
        $this.removeClass(invalidClass);

        // Convert possible decimal to dot and to number format
        value = value.replace(',', '.');
        value = +value;

        // And search for matching products
        searchCriteria[$this.data('search-key')] = value;
        self._changeSearchCriteria(searchCriteria);

        //results = self._searchByExcavatorClass(value);

        //self._showResults(results);
      } else {
        $this.addClass(invalidClass);
      }
    });
  }

  private _changeSearchCriteria(params) {
    var key,
        results = [];


    for(key in params) {
      if(params.hasOwnProperty(key)) {
        this.searchCriteria[key] = params[key];
      }
    }


    // Power is the main criteria for searching and overrides sizeClass
    if(this.searchCriteria.power) {

      results = this._filterProducts('power', this.searchCriteria.power);

      // Use this if power is not set
    } else if(this.searchCriteria.sizeClass) {

      // Excavator search returns uuids so we need to get products
      results = this._getProducts(this._searchByExcavatorClass(this.searchCriteria.sizeClass));
    } else if(this.excavatorModelProducts) {

      // Excavator model specific products
      results = this._getProducts(this.excavatorModelProducts);
    }


    if(results.length) {
      results = this._filterProducts('groundVibration', this.searchCriteria.groundVibration, results);
    }

    // We only want to show the first result
    this._showResults(results.splice(0,1));
  }

  private _filterProducts(filterType, value, filteredProducts?) {
    var results = [],
        product, i, l,
        productData = filteredProducts ? filteredProducts : this.productData;

    // if we already have filteredProducts passed

    for(i=0, l=productData.length;i<l;i++) {
      product = productData[i];

      switch(filterType) {
        case 'power':
          if(product.data.enginePowerMin && product.data.enginePowerMin <= value) {
            results.push(product);
          }
          break;
        case 'groundVibration':
          if(product.data.groundVibration && product.data.groundVibration === value) {

            // add extraInfo
            if(this.productResultsInfo && this.productResultsInfo.groundVibration) {
              product.extraInfo = this.productResultsInfo.groundVibration[value];
            }
            results.push(product);
          }
          break;
      }
    }


    switch(filterType) {

      // Sort engine power by closest matches
      case 'power':
        results.sort(function (a, b) {
          if(a.data.enginePowerMin < b.data.enginePowerMin) {
            return 1;
          } else if(a.data.enginePowerMin > b.data.enginePowerMin) {
            return -1;
          }

          return 0;
        });
        break;
    }

    return results;
  }

  /**
   * Parse products. Remove unwanted products etc.
   * @param {array} products data
   */
  private _parseProducts(data) {
    var products = [], i, l;

    // Check that product groups are allowed in search
    if (this.searchGroups && this.searchGroups.length) {
      for (i = 0, l = data.length; i < l; i++) {

        // Accept both group and sub group
        if (this.searchGroups.indexOf(data[i].group) !== -1 || this.searchGroups.indexOf(data[i].subGroup) !== -1) {
          products.push(data[i]);
        }
      }
    } else {

      // If no groups are selected, search all
      products = data;
    }

    return products;
  }

  public init() {
    var self = this,
        productListJSON = this.dom.$el.data('product-list-json')

    if(!this.dom.$el.length) {
      return;
    }

    this.excavatorsData = this.dom.$el.data('excavators');
    this.excavatorClasses = this.dom.$el.data('excavator-classes');

    this.productResultsInfo = this.dom.$el.data('results-extra-info');

    this.searchGroups = this.dom.$el.data('search-groups');

    this.listTemplate = this.dom.$el.find('.' + this.jsBlock + '__list-template').html();

    Mustache.parse(this.listTemplate)

    // Get product data
    Movax.xhr.get(productListJSON).then(function(res) {
      self.productData = self._parseProducts(res);
    });

    this._initExcavatorSelect();
    this._initMakeSelect();
    this._initExcavatorClassSearch();
    this._initGroundVibrationSelect();
    this._initResults();
  }
}

export { ProductSearch };
